// ═══════════════════════════════════════════════════════════
// CustomerGrid — сітка/список клієнтів з infinite scroll
// Server-paginated: parent owns the page fetch, we trigger loadMore
// when the sentinel enters the viewport.
// ═══════════════════════════════════════════════════════════
import React, { useEffect, useRef } from 'react';
import { useT } from '../contexts/I18nContext';
import CustomerCard from './CustomerCard';

function CustomerGrid({
  customers,
  categories,
  importanceLevels,
  onView,
  onEdit,
  onDelete,
  deletingId,
  onBook,
  onOrder,
  onSubscription,
  viewMode,
  hasMore,
  loading,
  onLoadMore,
}) {
  const { t } = useT();
  const loaderRef = useRef(null);

  useEffect(() => {
    const el = loaderRef.current;
    if (!el || !hasMore || loading || !onLoadMore) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) onLoadMore();
    }, { rootMargin: '300px' });
    obs.observe(el);
    return () => obs.disconnect();
  }, [hasMore, loading, onLoadMore]);

  if (loading && customers.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">⏳</div>
        <h3>{t('common.loading')}</h3>
      </div>
    );
  }
  if (customers.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">👥</div>
        <h3>{t('custGrid.noCustomersFound')}</h3>
        <p>{t('custGrid.tryChangeSearch')}</p>
      </div>
    );
  }
  return (
    <>
      <div className={viewMode === 'list' ? 'customer-list' : 'customer-grid'}>
        {customers.map(customer => (
          <CustomerCard
            key={customer.id}
            customer={customer}
            categories={categories}
            importanceLevels={importanceLevels}
            onView={onView ? () => onView(customer) : undefined}
            onEdit={() => onEdit(customer)}
            onDelete={() => onDelete(customer.id, customer.name)}
            isDeleting={deletingId === customer.id}
            onBook={() => onBook(customer)}
            onOrder={onOrder ? () => onOrder(customer) : undefined}
            onSubscription={onSubscription ? () => onSubscription(customer) : undefined}
            viewMode={viewMode}
          />
        ))}
      </div>
      {hasMore && (
        <div ref={loaderRef} style={{ textAlign: 'center', padding: '16px 0', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
          {t('common.loading')}...
        </div>
      )}
    </>
  );
}

export default CustomerGrid;
